import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { selectAllAccounts } from '@mkp/account/state';
import { LegalEntity } from '@mkp/legal-entity/models';
import { Store } from '@ngrx/store';
import { map, of, take } from 'rxjs';

export const LegalEntityVacancyListResolver: ResolveFn<LegalEntity> = (
  route: ActivatedRouteSnapshot
) => {
  const router = inject(Router);
  const store = inject(Store);
  const legalEntityId = route.paramMap.get('legalEntityId');

  if (!legalEntityId) {
    return of(new RedirectCommand(router.parseUrl(`${AppConfig.routes.selectAccountMembership}`)));
  }

  return store.select(selectAllAccounts).pipe(
    take(1),
    map(
      (accounts) =>
        accounts.find((account) => account.legalEntity.id === legalEntityId)?.legalEntity ??
        new RedirectCommand(router.parseUrl(`${AppConfig.routes.selectAccountMembership}`))
    )
  );
};
